import React from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";

import milk from "../images/milk.jpg";
import buffaloMilk from "../images/22.jpeg";
import freshPaneer from "../images/1.jpg";
import pureGhee from "../images/5.jpg";
import freshButter from "../images/Picture3.jpg";
import flavoredMilk from "../images/milk.jpg";
import freshCurd from "../images/23.jpeg";
import greekYogurt from "../images/9.jpeg";

import Quality_Assurance from "../images/16.jpg";

const Products = () => {
  const currentProducts = [
    {
      name: "Fresh Cow Milk",
      description: "Pure, farm-fresh cow milk with high nutritional value",
      image: milk,
      benefits: ["High protein", "Rich in calcium", "Fresh daily"],
      price: "Available",
    },
    {
      name: "Buffalo Milk",
      description: "Creamy buffalo milk perfect for traditional preparations",
      image: buffaloMilk,
      benefits: ["Higher fat content", "Rich taste", "Natural"],
      price: "Available",
    },
    {
      name: "Fresh Paneer",
      description: "Homemade paneer from pure milk, soft and nutritious",
      image: freshPaneer,
      benefits: ["High protein", "Fresh daily", "No preservatives"],
      price: "Available",
    },
    {
      name: "Pure Ghee",
      description: "Traditional pure ghee made from cow milk",
      image: pureGhee,
      benefits: ["Traditional method", "Pure ingredients", "Aromatic"],
      price: "Available",
    },
    {
      name: "Fresh Butter",
      description: "Creamy homemade butter from fresh cream",
      image: freshButter,
      benefits: ["Fresh cream", "No additives", "Rich taste"],
      price: "Available",
    },
    {
      name: "Flavored Milk",
      description: "Natural flavored milk varieties - Chocolate, Strawberry",
      image: flavoredMilk,
      benefits: ["Natural flavors", "No artificial colors", "Kids favorite"],
      price: "Available",
    },
    {
      name: "Fresh Curd",
      description: "Homemade curd with live cultures",
      image: freshCurd,
      benefits: ["Probiotic", "Digestive health", "Fresh daily"],
      price: "Available",
    },
    {
      name: "Greek Yogurt",
      description: "Thick, creamy Greek-style yogurt",
      image: greekYogurt,
      benefits: ["High protein", "Thick consistency", "Healthy"],
      price: "Available",
    },
  ];

  const futureProducts = [
    {
      name: "Fortified Yogurt",
      description: "Nutrient-enhanced yogurt with added vitamins and minerals",
      status: "Coming Soon",
    },
    {
      name: "Millet Ice Cream",
      description: "Healthy ice cream made with traditional millets",
      status: "In Development",
    },
    {
      name: "Functional Beverages",
      description: "Health-focused dairy beverages with added nutrients",
      status: "Planning Phase",
    },
    {
      name: "Khoa",
      description: "Traditional milk solids for Indian sweets",
      status: "Available",
    },
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section
        className="py-5 text-white hero_sec"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Our Premium Products</h1>
              <p className="fs-5">
                From farm to table - Pure, nutritious, and delicious dairy
                products
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Current Products */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Available Now</h2>
              <p className="fs-5 text-muted">
                High-quality dairy products made with care and tradition
              </p>
            </Col>
          </Row>
          <Row>
            {currentProducts.map((product, index) => (
              <Col lg={3} md={4} sm={6} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    className="product-image"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title className="fw-bold h5">
                      {product.name}
                    </Card.Title>
                    <Card.Text className="text-muted small flex-grow-1">
                      {product.description}
                    </Card.Text>
                    <div className="mb-3">
                      {product.benefits.map((benefit, idx) => (
                        <Badge
                          key={idx}
                          bg="success"
                          className="me-1 mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          {benefit}
                        </Badge>
                      ))}
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <Badge bg="primary">{product.price}</Badge>
                      {/* <Button variant="outline-primary" size="sm">
                        Enquire Now
                      </Button> */}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Future Products */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Coming Soon</h2>
              <p className="fs-5 text-muted">
                Exciting new products in development
              </p>
            </Col>
          </Row>
          <Row>
            {futureProducts.map((product, index) => (
              <Col md={6} key={index} className="mb-4">
                <Card className="border-0 shadow-sm hover-lift">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <Card.Title className="fw-bold">
                        {product.name}
                      </Card.Title>
                      <Badge
                        bg={
                          product.status === "Available"
                            ? "success"
                            : product.status === "Coming Soon"
                            ? "warning"
                            : "info"
                        }
                      >
                        {product.status}
                      </Badge>
                    </div>
                    <Card.Text className="text-muted">
                      {product.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Quality Assurance */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <h2 className="display-5 fw-bold mb-4">Quality Assurance</h2>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">
                  🔬 IoT Milk Analyzer Technology
                </h5>
                <p className="text-muted">
                  Advanced testing ensures quality and fair pricing for our
                  producers
                </p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">
                  ✅ 100% Natural Products
                </h5>
                <p className="text-muted">
                  No artificial preservatives, colors, or harmful additives
                </p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">
                  🏆 Government Certified
                </h5>
                <p className="text-muted">
                  All products meet government quality standards and regulations
                </p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold text-primary">
                  🚚 Fresh Daily Delivery
                </h5>
                <p className="text-muted">
                  Farm-fresh products delivered daily to ensure maximum
                  freshness
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <img
                src={Quality_Assurance}
                alt="Quality testing"
                className="img-fluid rounded shadow-lg hover-lift"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section
        className="py-5 text-white"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">
                Want to Order Our Products?
              </h2>
              <p className="fs-5 mb-4">
                Contact us for bulk orders, retail inquiries, or to find your
                nearest outlet
              </p>
              <div className="d-flex justify-content-center gap-3">
                <Button variant="light" size="lg" className="px-4">
                  Contact Us
                </Button>
                <Button variant="outline-light" size="lg" className="px-4">
                  Find Outlets
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Products;
